import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import AnalyticsTracker from "./Components/AnalyticsTracker";

ReactGA.initialize("G-7QRLMY59DY");
ReactGA.send("pageview");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AnalyticsTracker />
    <App />
  </BrowserRouter>
  
);